module.exports = __webpack_public_path__ + "15_hair_gold.4c189acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/15_hair_gold.png
// module id = O+tv
// module chunks = 0